import type { PaymentTransaction } from "../../domain/entities/PaymentTransaction";

export interface PaymentTransactionHttp {
  code: string;
  amount: number;
  reference_code?: string;
  referenceCode?: string;
  status: string;
  payment_method_code?: string | null;
  payment_method?: string | null;
  paymentMethodCode?: string | null;
  paymentMethod?: string | null;
  payment_method_name?: string | null;
  paymentMethodName?: string | null;
  created_at?: string;
  createdAt?: string;
  updated_at?: string;
  updatedAt?: string;
}

export const mapPaymentTransaction = (transaction: PaymentTransactionHttp): PaymentTransaction => {
  const paymentMethodCode =
    transaction.payment_method_code ??
    transaction.payment_method ??
    transaction.paymentMethodCode ??
    transaction.paymentMethod ??
    null;

  const paymentMethodName =
    transaction.payment_method_name ??
    transaction.payment_method ??
    transaction.paymentMethodName ??
    transaction.paymentMethod ??
    null;

  const referenceCode = transaction.reference_code ?? transaction.referenceCode ?? "";

  const createdAt = transaction.created_at ?? transaction.createdAt;
  const updatedAt = transaction.updated_at ?? transaction.updatedAt;

  return {
    code: transaction.code,
    amount: transaction.amount,
    referenceCode,
    status: transaction.status,
    paymentMethodCode,
    paymentMethodName,
    createdAt: createdAt ? new Date(createdAt) : new Date(),
    updatedAt: updatedAt ? new Date(updatedAt) : new Date(),
  };
};
